<!-- <div class="notMobile">
  <p-table [value]="viewItems" [columns]="selectedCols" #dt
    styleClass="p-datatable-striped p-datatable-gridlines p-datatable-sm mt-3" datakey="document.Id" [loading]="loading"
    [rowHover]="true" [scrollable]="true" scrollDirection="both" responsiveLayout="scroll" [reorderableColumns]="true"
    [rowsPerPageOptions]="[25,50,100]" [(selection)]="tableSelections" selectionMode="multiple">

    <ng-template pTemplate="header" let-columns>
      <tr>
        <td style="min-width:50px;width: 3rem;text-align: center;">
          <input type="checkbox" aria-label="Select All Checkbox" class="form-check-input" [checked]="allItemsSelected" (change)="toggleAllRows($event)">
        </td>
        <th style="min-width:50px;width: 3rem;text-align: center;">
          Properties
        </th>
        <th style="width:100px;text-align: center;">Accession #
        </th>
        <th *ngFor="let col of columns" pReorderableColumn pResizableColumn pTooltip="{{col.header}}"
          tooltipPosition="top">
          {{col.header}}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td style="min-width:50px;width: 3rem;text-align: center;">
          <input type="checkbox" aria-label="Select Item Checkbox" class="form-check-input" [checked]="getRowSelection(rowData)"
            (change)="onRowSelectChange(rowData, $event)">
        </td>
        <td style="min-width:50px;max-width:50px;text-align: center;">
          <a class="bs-dark toolbar-icon text-primary" aria-label="Document Properties"
            (click)="showProperties(rowData.document);">
            <i *ngIf="rowData.document.ItemType == 'package'" class="fa fa-box-archive"
              pTooltip="Package Properties"></i>
            <i *ngIf="rowData.document.ItemType == 'legacy'" class="fa fa-microscope"
              pTooltip="Legacy Item Properties"></i>
            <i *ngIf="rowData.document?.ItemType === 'doc'" class="fa fa-file-lines" 
            pTooltip="Document Properties"></i>
          </a>
        </td>
        <td style="text-align: center;">
          <span *ngIf="rowData.document.ItemType == 'legacy'">
            <app-dialog-legacy-download [title]="rowData.document?.AccessionNumber" [accessionNumber]="rowData.document?.AccessionNumber" [microformAddress]="rowData.document?.MicroformAddresses">
            </app-dialog-legacy-download>
          </span>

          <a *ngIf="rowData.document.ItemType != 'legacy'" class="text-primary bs-dark"
            href="{{rowData.document?.Url}}" target="_blank" pTooltip="Click to Download">{{rowData.document?.AccessionNumber}}</a>
        </td>

        <td *ngFor="let col of columns"
          pTooltip="{{rowData['document'][col.field]}}" tooltipPosition="top">
          {{rowData['document'][col.field] | slice:0:80 }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div> -->

<!-- Mobile View displays Table in a Stack -->
<div>
  <p-table 
  [value]="viewItems" 
  [columns]="selectedCols" 
  styleClass="p-datatable-striped p-datatable-gridlines p-datatable-sm mt-3" 
  datakey="document.Id" 
  [loading]="loading"
  responsiveLayout="stack" 
  [reorderableColumns]="true"
  [rowsPerPageOptions]="[25,50,100]" 
  [(selection)]="tableSelections" 
  selectionMode="multiple"
  scrollHeight="flex">

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="text-align: center;">
          <input type="checkbox" aria-label="Select All Checkbox" class="form-check-input" [checked]="allItemsSelected" (change)="toggleAllRows($event)">
        </th>
        <th pTooltip="Properties">
          Properties
        </th >
        <th pTooltip="Accession Number">
          Accession #
        </th>
        <th *ngFor="let col of columns" pReorderableColumn pResizableColumn pTooltip="{{col.header}}"
          tooltipPosition="top">
          {{col.header}}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td style="text-align: center;">
          <span class="p-column-title">Select for Download</span>
          <input type="checkbox" aria-label="Select Item Checkbox" class="form-check-input" [checked]="getRowSelection(rowData)"
            (change)="onRowSelectChange(rowData, $event)">
        </td>
        <td style="text-align: center;">
          <span class="p-column-title">Properties</span>
          <a class="bs-dark toolbar-icon text-primary"
            (click)="showProperties(rowData.document);">
            <i *ngIf="rowData.document.ItemType == 'package'" class="fa fa-box-archive"
              pTooltip="Package Properties" tooltipPosition="left"></i>
            <i *ngIf="rowData.document.ItemType == 'legacy'" class="fa fa-microscope"
              pTooltip="Legacy Item Properties" tooltipPosition="left"></i>
            <i *ngIf="rowData.document?.ItemType === 'doc'" class="fa fa-file-lines" 
            pTooltip="Document Properties" tooltipPosition="left"></i>
          </a>
        </td>
        <td>
          <span class="p-column-title">Accession #</span>
          <span *ngIf="rowData.document.ItemType == 'legacy'">
            <app-dialog-legacy-download [title]="rowData.document?.AccessionNumber" [accessionNumber]="rowData.document?.AccessionNumber" [microformAddress]="rowData.document?.MicroformAddresses">
            </app-dialog-legacy-download>
          </span>

          <a *ngIf="rowData.document.ItemType != 'legacy'" class="text-primary bs-dark"
            href="{{rowData.document?.Url}}" target="_blank" pTooltip="Click to Download" tooltipPosition="left">{{rowData.document?.AccessionNumber}}</a>
        </td>

        <td *ngFor="let col of columns"
            pTooltip="{{col.header === 'Date Added (EST)'
                  ? (rowData?.document?.[col.field] | date:'yyyy-MM-dd hh:mm a') + ' EST'
                  : (rowData?.document?.[col.field] | addSpaceAfterComma)}}"
            [tooltipDisabled]="!rowData?.document?.[col.field]"
        tooltipPosition="top">
          <span class="p-column-title">{{col.header}}</span>
          
          <span *ngIf="col.header === 'Date Added (EST)'">
            <!-- format for the AM/PM -->
            {{ rowData['document'][col.field] | date:'yyyy-MM-dd hh:mm a' }} EST
          </span>
          <span *ngIf="col.header === 'Document Size'">
            <!-- format for the AM/PM -->
            {{ rowData['document'][col.field] | fileSize }}
          </span>
          <span *ngIf="(col.header !== 'Date Added (EST)') && (col.header !== 'Document Size')">
            {{ rowData['document'][col.field] | addSpaceAfterComma | slice:0:110 }}
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>